export default __webpack_public_path__ + "static/media/s3-005.ac552106.jpg";